import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
import { BackendResourcesType, AppsettingsConfig } from "../../interfaces/msal-config";

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export function loggerCallback(logLevel: LogLevel, message: string) {
  //  console.log(logLevel);
  //  console.log(message);
}


export function MSALInstanceFactory(config: AppsettingsConfig): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.credentials.clientId,
      authority: `${config.credentials.authorityBaseUrl} ${config.credentials.tenantId}`,
      redirectUri: config.configuration.redirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      // storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: true
      }
    }
  })
}

export function MSALInterceptorConfigFactory(
  config: BackendResourcesType
): MsalInterceptorConfiguration {
  let keys = Object.keys(config);
  const protectedResourceMap = new Map<string, Array<string>>();

  keys.forEach((key: string) => {
    protectedResourceMap.set(config[key].resourceUri, config[key].resourceScopes);
  })

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}
